import { settings } from '@/main/config/settings'

export const makeApiUrl = (path: string): string => `${settings.BASE_URL}${path}`
export const makeApiV2Url = (path: string): string => `${settings.BASE_URL}/v2${path}`

/**
 * GET de perfil do usuário (`/v2/user/account/profile`). Reúso compartilhado
 * por contact-verification, career-mentor e o connectivity-probe (que o usa
 * como "ping" de alcance da API) — evita divergência do path entre os pontos.
 */
export const makeUserAccountProfileUrl = (): string => makeApiV2Url('/user/account/profile')
export const makeViaCepUrl = (): string => settings.VIACEP_BASE_URL
export const makeSkillExplorerCatalogUrl = (path: string): string =>
  `${settings.SKILL_EXPLORER_CATALOG_BASE_URL}/catalog-output/${path}`
